var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8819_6851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 10.6667H10.6667V12H5.33341V10.6667ZM5.33341 8.00001H10.6667V9.33334H5.33341V8.00001ZM9.33342 1.33334H4.00008C3.26675 1.33334 2.66675 1.93334 2.66675 2.66668V13.3333C2.66675 14.0667 3.26008 14.6667 3.99341 14.6667H12.0001C12.7334 14.6667 13.3334 14.0667 13.3334 13.3333V5.33334L9.33342 1.33334ZM12.0001 13.3333H4.00008V2.66668H8.66675V6.00001H12.0001V13.3333Z",
    fill: "#0076FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8819_6851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconTree);
export default __webpack_public_path__ + "static/media/fileIconTree.9fd2469faacd7e6805932d41bc35651c.svg";
export { ForwardRef as ReactComponent };